// GSR team will bring ChinaDomains and pepperstone.me in later then we can remove the chinaDomains and vietSaudiIndoDomains
export const chinaDomains = (() => {
  // hardcoded list of China domains until GSR team fully supports dynamic domains
  const staticChinaDomains = [
    "hujiao-shitou.com",
    "hujiaoshitou-zh.com",
    "hujiaoshitou-cn.com",
    "hujiaoshitou-cn.org",
    "hujiaoshitou-zh.net",
    "hujiaoshitou-zh.org",
    "hujiaoshitou-cn.net",
  ];

  // dynamically load additional domains from the environment variable
  const dynamicChinaDomains = (() => {
    const envDomains = import.meta.env.VITE_GSR_CHINA_DOMAINS;
    if (typeof envDomains !== "string" || !envDomains.trim()) {
      return [];
    }
    return envDomains.split(",").map((domain) => domain.trim());
  })();

  return [...staticChinaDomains, ...dynamicChinaDomains];
})();

export const getDomain = (): string => {
  const hostname = window.location.hostname;
  const parts = hostname.split(".");
  const mainDomain = parts.slice(-2).join("."); // Get the last two parts of the hostname
  return mainDomain;
};

export const getGSRDomains = (): string[] => {
  const gsrDomains = import.meta.env.VITE_GSR_DOMAINS;
  if (typeof gsrDomains !== "string" || !gsrDomains.trim()) {
    return [];
  }
  return gsrDomains.split(",").map((domain) => domain.trim());
};

export const isServedToChina = (): boolean =>
  chinaDomains.includes(getDomain());

export const isServedToGSRDomains = (): boolean => {
  const gsrDomains = getGSRDomains();
  return gsrDomains.includes(getDomain());
};

export const getUrl = (url: string): string => {
  if (isServedToChina() || isServedToGSRDomains()) {
    const altDomain = getDomain();
    return url.replace("pepperstone.com", altDomain);
  }
  return url;
};

export const getAPIBaseUrl = (url: string): string => {
  if (isServedToChina() || isServedToGSRDomains()) {
    const altDomain = getDomain();
    return url.replace("pepperstone.com", altDomain);
  }
  return url;
};

const authPrefixes = {
  prd: "auth",
  stg: "staging.auth",
  dev: "dev.auth",
} as const;

const isLocalHost = (hostname: string): boolean =>
  !hostname.includes(".") ||
  hostname.endsWith(".localhost") ||
  /^\d{1,3}(\.\d{1,3}){3}$/.test(hostname);

const isAuthEnv = (env: string): env is keyof typeof authPrefixes =>
  Object.hasOwn(authPrefixes, env);

export const getAuth0Domain = (): string => {
  if (isLocalHost(window.location.hostname)) {
    return import.meta.env.VITE_AUTH0_DOMAIN;
  }
  const env = import.meta.env.VITE_ENVIRONMENT;
  const authPrefix = isAuthEnv(env) ? authPrefixes[env] : authPrefixes.dev;
  return `${authPrefix}.${getDomain()}`;
};
